export interface CalendarData {
  id: string
  title: string
  invitees: string
  matching_terms: string[]
  date: string
}

export interface ContactsData {
  id: string
  name: string
  company: string
  emails: string[]
  phones: string[]
  matching_terms: string[]
  last_contact: string
}

export interface DropboxData {
  id: string
  path: string
  title: string
  shared_with?: string[]
  matching_terms: string[]
  created: string
}

export interface SlackData {
  id: string
  channel: string
  author: string
  message: string
  timestamp: string
  matching_terms: string[]
}

export interface TweetData {
  user: string
  message: string
  timestamp: string
  matching_terms: string[]
}

export type SearchItemData =
  | CalendarData
  | ContactsData
  | DropboxData
  | SlackData
  | TweetData

export default class SearchItem {
  readonly data: SearchItemData

  constructor(data: SearchItemData) {
    this.data = data
  }

  get matchingTerms() {
    return this.data.matching_terms
  }

  matchesQuery(query: string) {
    for (let i = 0; i < this.matchingTerms.length; i++) {
      if (this.matchingTerms[i].includes(query)) {
        return true
      }
    }

    return false
  }
}
